module.exports = __webpack_public_path__ + "static/img/ch.f99c90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/common/ch.png
// module id = wkj8
// module chunks = 11